import { useState, useContext } from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, Divider, Typography } from "@mui/material";

import ProfileQuestionContext from "../../../../contexts/ProfileQuestionContext";

const Header = () => {
  const { org, orgList, setOrg } = useContext(ProfileQuestionContext);

  const handleChange = (val) => {
    setOrg(val);
  };

  if (orgList.length > 0) {
    return (
      <Grid container justifyContent="center" spacing={2} style={{padding: 20}}>
        <Grid item md={6} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Orgs</InputLabel>
            <Select
              value={org}
              label="Org name"
              onChange={(e) => handleChange(e.target.value)}
            >
              {orgList.map((option) => {
                return (
                  <MenuItem key={option._id} value={option._id}>
                    {option.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
            <Divider />
        </Grid>
      </Grid>
    );
  }

  return (
    <div style={{padding: 20}}>
      <Typography>Create questions then add them to a question group. In each event settings tab, assign the question group to the event. Each group will show up as a profile type in a user's profile</Typography>
    </div>
  );
};

export default Header;
